export function cx(...values) {
    return values.filter((v) => typeof v === 'string' && v.length > 0).join(' ');
}
//# sourceMappingURL=cx.js.map